/* START_MODULE_CONTRACT
 * PURPOSE: Frontend model: Feature.
 * SCOPE: DTO mapping / status helpers.
 * DEPENDS: M-FE-API
 * LINKS: M-FE-API, UC-020
 * ROLE: TYPES
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * Feature - Клиентская модель фичи со статусами BACKLOG|IN_PROGRESS|ARCHIVED.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-28 - UC-020: BACKLOG, isBacklog, isOnTimeline.
 * LAST_CHANGE: 2026-07-02 - GRACE coverage: реальный class-контракт и парный END_CLASS.
 * END_CHANGE_SUMMARY
 */

import FeatureEstimate from './FeatureEstimate';

const STATUS_LABELS = {
  BACKLOG: 'Бэклог',
  IN_PROGRESS: 'В работе',
  ARCHIVED: 'В архиве',
};

/* START_CLASS_Feature */
/* START_CONTRACT: Feature
 * PURPOSE: Клиентская модель фичи с оценками, статусом и производными полями.
 * INPUTS: { id, projectId, name, status, sortOrder, startDate, createdAt, estimates }.
 * OUTPUTS: экземпляр Feature; геттеры statusLabel, isArchived, isBacklog, isOnTimeline.
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-API, M-FEATURE, UC-020
 * END_CONTRACT: Feature
 */
export default class Feature {
  constructor({ id, projectId, name, status, sortOrder, startDate, createdAt, estimates }) {
    this.id = id;
    this.projectId = projectId;
    this.name = name ?? '';
    this.status = status ?? 'IN_PROGRESS';
    this.sortOrder = sortOrder ?? 0;
    this.startDate = startDate ?? null;
    this.createdAt = createdAt ? new Date(createdAt) : null;
    this.estimates = (estimates ?? []).map(FeatureEstimate.fromResponse);
  }

  get statusLabel() {
    return STATUS_LABELS[this.status] ?? this.status;
  }

  get isArchived() {
    return this.status === 'ARCHIVED';
  }

  get isBacklog() {
    return this.status === 'BACKLOG';
  }

  get isOnTimeline() {
    return this.status === 'IN_PROGRESS';
  }

  static fromResponse(data) {
    return new Feature(data);
  }
}
/* END_CLASS_Feature */
